import {DIGITAL_CARD} from '@zzng/common/constants/scheme';
import {openDigitalCardOnTop} from '@zzng/common/scheme/digitalcard';
import {appendQueryParamToUrl} from '@zzng/common/utils/common';

import CardBestSection from '@/root/components/CardBestSection';
import More from '@/root/components/More';
import {HomeRes} from '@/root/models/home';

import {TIARA_ACTION, TIARA_PAGE_NAME} from '@/shared/constants/tiara';
import useTiara from '@/shared/hooks/useTiara';

type Props = {
  bestSection: HomeRes['bestSection'];
  benefits: HomeRes['benefits'];
};
const CardBenefits = ({bestSection, benefits}: Props) => {
  const {trackEvent} = useTiara({pageName: TIARA_PAGE_NAME.HOME});

  // 이벤트 상세 페이지 진입시 헤더 타입을 CLOSE로 변경하기 위해 direct=true를 추가
  const openEventBenefitDetail = (url: string) => {
    openDigitalCardOnTop(appendQueryParamToUrl(url, {direct: true}));
  };

  const onClickBenefit = (benefit: HomeRes['benefits'][number], index: number) => {
    const url = `${DIGITAL_CARD.EVENT_BENEFIT}/${benefit.eventId}`;
    trackEvent({action: TIARA_ACTION.BENEFIT_LIST_CLICK, customProps: {title: benefit.title, order: `${index}`, url}});
    openEventBenefitDetail(url);
  };

  const onClickMore = () => {
    trackEvent({action: TIARA_ACTION.BENEFIT_VIEW_CLICK});
    openDigitalCardOnTop(DIGITAL_CARD.EVENT_BENEFIT);
  };

  return (
    <>
      <h3 className="tit_section type2">
        <span role="text">
          <span className="txt_tit">카드 혜택</span>
        </span>
      </h3>
      {bestSection && <CardBestSection bestSection={bestSection} />}
      <ul className="list_benefit">
        {benefits.map((benefit, index) => (
          <li key={benefit.eventId} className="item_benefit">
            <button type="button" className="link_benefit" onClick={() => onClickBenefit(benefit, index)}>
              <span className="thumb_benefit" style={{backgroundImage: `url(${benefit.imageUrl})`}}></span>
              <span className="box_info">
                <strong className="tit_service" role="text">
                  {benefit.title}
                </strong>
                <span className="txt_sub" role="text">
                  {benefit.subTitle}
                </span>
              </span>
              <span className="icon icon_arr_right_type7">자세히 보기</span>
            </button>
          </li>
        ))}
      </ul>
      <More show text="혜택 바로가기" onClickMore={onClickMore} direction="right" />
    </>
  );
};

export default CardBenefits;
